export enum KeyboardKeyEnum { ESCAPE = "Escape" }

export enum KeyboardEventEnum { KEYDOWN = "keydown" }
